<template>
  <a
    v-if="isVisible"
    :href="createBookingHref"
    class="booking-create"
    @click.prevent="goCreateBooking"
  >
    <Icon name="plus-circle" size="xl" />
    <span class="is-sr-only">Opret booking</span>
  </a>
</template>

<script>
import { defineComponent } from 'vue'
import { useComposition } from '@/compositions/composition'
import Icon from '@/components/Icon.vue'

export default defineComponent({
  name: 'BookingCreateFab',
  components: {
    Icon
  },
  setup() {
    const { global } = useComposition()
    return { global }
  },
  computed: {
    isVisible() {
      return this.global.user && Object.prototype.hasOwnProperty.call(this.global.user, 'id')
    },
    todayYmd() {
      const d = new Date()
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },
    preferredDate() {
      return this.global.navigation && this.global.navigation.calendarDate
        ? this.global.navigation.calendarDate
        : this.todayYmd
    },
    createBookingHref() {
      if (this.preferredDate !== this.todayYmd) {
        return '/booking/opret?date=' + encodeURIComponent(this.preferredDate)
      }
      return '/booking/opret'
    }
  },
  methods: {
    goCreateBooking() {
      if (this.global.navigation) {
        this.global.navigation.navigatedFrom = this.global.navigation.navigatedFrom || 'Calendar'
        this.global.navigation.calendarDate = this.preferredDate
      }
      this.$router.push(
        this.preferredDate !== this.todayYmd
          ? { path: '/booking/opret', query: { date: this.preferredDate } }
          : '/booking/opret'
      )
    }
  }
})
</script>
